import Disclaimer from '../../../Disclaimer/Disclaimer';
import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';

const SeatMapDisclaimer: React.FC = ({ children }) => {
	const { SeatMapDisclaimerStyles: theme } = useTheme('SeatMap');

	return (
		<Disclaimer
			wrapperClassName={theme.disclaimer__wrp}
			className={cn(theme.disclaimer_columnContent, theme.disclaimer)}
		>
			{children}
		</Disclaimer>
	);
};

export default SeatMapDisclaimer;
